import React from 'react';
import { Helix2000Character } from '../../../../../shared/CharacterTypes';
import { playerCardStyle, sectionHeaderStyle } from './styles';

interface OnlinePlayersProps {
  otherPlayers: Map<string, Helix2000Character>;
}

export const OnlinePlayers: React.FC<OnlinePlayersProps> = ({ otherPlayers }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Online Players ({otherPlayers.size})</div>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {otherPlayers.size === 0 ? (
          <div style={{ textAlign: 'center', color: '#666', padding: '20px', fontSize: '12px' }}>
            No other players online
          </div>
        ) : (
          Array.from(otherPlayers.values()).map(p => (
            <div key={p.id} style={playerCardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <span style={{ fontWeight: 'bold', color: '#fff' }}>{p.id}</span>
                <span style={{
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '10px',
                  background: 'rgba(52, 152, 219, 0.2)',
                  color: '#3498db'
                }}>
                  {p.class || 'Unknown'}
                </span>
              </div>
              <div style={{ fontSize: '11px', color: '#888', display: 'flex', justifyContent: 'space-between' }}>
                <span>Pos: ({p.position.x.toFixed(0)}, {p.position.y.toFixed(0)})</span>
                <span>Lv. {p.level || 1}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};
